<template>
  <b-container fluid class="p-0">
    <b-row class="mt-3">
      <b-col
        cols="12"
        md="8"
      >
        <b-button
          class="mr-1 mt-1 mt-lg-0"
          size="sm"
          variant="outline-secondary"
          @click="actionHandler"
        >
          <s-icon
            name="print"
            class="mr-1"
          />
          {{ $t('actions.print') }}
        </b-button>
        <b-button
          class="comparative-analysis__subtitle-button mt-1 mt-lg-0"
          size="sm"
          variant="outline-secondary"
          @click="goToDetails"
        >
          <span class="material-icons-round">
            bookmark_border
          </span>
          {{ $t('general.subtitle') }}
        </b-button>
      </b-col>
      <b-col
        class="text-right"
        cols="12"
        md="4"
      >
        <b-form-group>
          <b-form-radio-group
            buttons
            button-variant="outline-primary"
            size="sm"
            v-model="viewProxy"
            :options="views"
          />
        </b-form-group>
      </b-col>
      <details-modal
        :value="showModal"
        @input="handleModal"
      />
    </b-row>
    <b-row>
      <b-col>
        <summary-transformer-info
          class="mb-3 mt-1"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span
          v-if="showTableLabel"
          class="comparative-analysis__title mr-lg-3"
        >
          {{ $t('fields.engineering.chromatography.samples') }}
        </span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SummaryTransformerInfo from '@/domain/components/installation/supervision/SummaryTransformerInfo';
import views from '@/domain/data/installation/engineering/chromatography/methodsAndDiagnostics/comparativeAnalysis/views';
import DetailsModal from '../DetailsModal';

export default {
  components: {
    DetailsModal,
    SummaryTransformerInfo,
  },
  props: {
    view: String,
    sampleIds: Array,
    assetModuleId: String,
  },
  data: () => ({
    showModal: false,
  }),
  computed: {
    showTableLabel() {
      return this.view === views.CHARTS;
    },
    actionHandler() {
      return this.showTableLabel ? this.openChartsPrintPage : this.openTablePrintPage;
    },
    viewProxy: {
      get() {
        return this.view;
      },
      set(value) {
        this.$emit('update:view', value);
      },
    },
    views() {
      return [
        {
          value: views.TABLE,
          text: this.$t('general.table'),
        },
        {
          value: views.CHARTS,
          text: this.$t('general.charts'),
        },
      ];
    },
  },
  methods: {
    openTablePrintPage() {
      const routeData = this.$router.resolve({
        name: 'clean-view.chromatography.methods-and-diagnostics.comparative-analysis-table.print',
        params: this.$route.params,
        query: {
          sampleIds: this.sampleIds,
          assetModuleId: this.assetModuleId,
        },
      });
      window.open(routeData.href, '_blank');
    },
    handleModal(value) {
      this.showModal = value;
    },
    goToDetails() {
      this.handleModal(true);
    },
    openChartsPrintPage() {
      const routeData = this.$router.resolve({
        name: 'clean-view.chromatography-graph.print',
        params: this.$route.params,
        query: {
          sampleIds: this.sampleIds,
        },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"

  .comparative-analysis
    &__title
      font-size: 1.4rem
      vertical-align: middle
      +media-max-md()
        display: block
    &__subtitle-button
      & span.material-icons-round
        font-size: 1.2rem
        vertical-align: bottom
</style>
